import { Component } from '@angular/core';

@Component({
  selector: 'app-woop-background',
  templateUrl: './woop-background.component.html',
  styleUrls: ['./woop-background.component.scss']
})

export class WoopBackgroundComponent {}
